import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../utilities/cookies";
import Loading from "../../components/Loading";

const RedirectPage = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const redirectRaw = params.get("redirect");

    try {
      if (!redirectRaw) {
        throw new Error("Missing redirect parameter");
      }

      const decodedRedirect = decodeURIComponent(redirectRaw);

      const redirectUrl = new URL(decodedRedirect, window.location.origin);

      const cookieRaw = getCookie("user");
      let user = null;
      if (cookieRaw) {
        try {
          user =
            typeof cookieRaw === "string" ? JSON.parse(cookieRaw) : cookieRaw;
        } catch (parseErr) {
          user = null;
        }
      }

      const isLoggedIn = Boolean(user && user.user && user.user._id);

      if (isLoggedIn) {
        const pathSegments = redirectUrl.pathname.split("/").filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1];
        if (
          lastSegment === "login" ||
          lastSegment === "signup" ||
          lastSegment === "register"
        ) {
          pathSegments.pop();
          redirectUrl.pathname = pathSegments.length
            ? `/${pathSegments.join("/")}`
            : "/";
        }

        redirectUrl.searchParams.set("userId", user.user._id);
        if (user.refreshToken) {
          redirectUrl.searchParams.set("refreshToken", user.refreshToken);
        }
      } else {
      }
      window.location.replace(redirectUrl.toString());
    } catch (e) {
      // console.error("Redirect error:", e);
      window.location.replace(window.location.origin);
    }
  }, [search]);

  return <Loading />;
};

export default RedirectPage;